import { memo } from 'react'
import HTMLRenderer from 'react-html-renderer'

interface Props {
  shouldBreakLines?: boolean
  text: string
}

function DealPageHeadingText({ shouldBreakLines = false, text }: Props) {
  if (!text.trim()) {
    return
  }

  return <HTMLRenderer
    html={text}
    components={{
      br: shouldBreakLines ? () => <br /> : () => null,
    }}
  />
}

export default memo(DealPageHeadingText)
